
<del *ngIf="product.price < product.priceNormal" class="text-muted text-normal">{{product.priceNormal * 13 | currency: "MAD" }}</del>{{product.price * 13 | currency : "MAD" }}

<!--<del *ngIf="product.price < product.priceNormal" class="text-muted text-normal">
  {{ product.priceNormal * 12 | currency:'MAD':'symbol':'1.2-2':'fr-MA' }}
</del>
{{ product.price * 12 | currency:'MAD':'symbol':'1.2-2':'fr-MA' }}-->
